import type { LevelNameLocal } from '../../../../api/types/LevelEntityLocal';

/** Niveles jerárquicos genéricos válidos (espejo del enum `LevelName` del contrato). */
export const LEVEL_NAMES: LevelNameLocal[] = ['LEVEL_1', 'LEVEL_2', 'LEVEL_3'];

/** Type guard de un `level` que llega por la URL (path param). */
export function isLevelName(value: string): value is LevelNameLocal {
    return (LEVEL_NAMES as string[]).includes(value);
}

/**
 * TD-WEBAPP-023: nombre LEGIBLE de un nivel cuando la APP del tenant aún no es resoluble client-side.
 *
 * El nombre real de cada nivel (ej. "Sucursal", "Región") vive en la `Application` del tenant
 * (`Application.levels[].displayName`), pero HOY no existe un endpoint/hook que resuelva
 * tenant → su aplicación → displayName del nivel (`TenantDetail` no expone `applicationId` ni los
 * niveles de la app — verificado en backoffice.gen.ts). Hasta que ese seam exista, la pantalla
 * genérica cae a este label genérico ("Nivel 1/2/3"), que NO es el "LEVEL_1" crudo (respeta la regla
 * anti-nombres) pero tampoco es el nombre de negocio real.
 *
 * Cuando el caller SÍ tiene el `displayName` real (ej. lo trae de la app), debe pasarlo por prop y
 * NO usar este fallback.
 */
const FALLBACK_LEVEL_LABEL: Record<LevelNameLocal, string> = {
    LEVEL_1: 'Nivel 1',
    LEVEL_2: 'Nivel 2',
    LEVEL_3: 'Nivel 3',
};

export function fallbackLevelDisplayName(level: LevelNameLocal): string {
    return FALLBACK_LEVEL_LABEL[level];
}
